/* Carta de producto - Aceitunas Lopez
   ------------------------------------------------------------------
   El boton del final de la carta sube hasta el selector de kilos.

   TRES COSAS QUE HAY QUE SABER ANTES DE TOCAR ESTO

   1. El destino es el bloque _al-tramos, que pinta <div class="altr"
      data-altr>. No sirve apuntar a un formulario /cart/add porque
      esta ficha no usa el boton de compra estandar del tema: el
      bloque monta la cesta por su cuenta y no hay formulario. Un
      href="#" a secas tampoco vale: eso lleva al principio de la
      pagina, que es justo lo que hacia antes.

   2. La columna de informacion es sticky en escritorio, asi que se
      mueve mientras dura el desplazamiento y la posicion calculada al
      principio se queda corta. Por eso se recalcula una vez al final.

   3. El desplazamiento se anima a mano con requestAnimationFrame
      porque no siempre se puede confiar en el navegador, y ademas hay
      un respaldo por si rAF no llega a dispararse (en una pestana en
      segundo plano no dispara nunca): a los 400 ms, si no ha
      empezado, se salta sin animacion.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var MARGEN = 110; /* alto aproximado de la cabecera fija */

  function destino() {
    return document.querySelector('[data-altr]')
      || document.querySelector('.altr')
      || document.querySelector('.product-detail__information');
  }

  function objetivoY(el) {
    return Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - MARGEN);
  }

  function subir(e) {
    if (e) e.preventDefault();

    var el = destino();
    if (!el) { window.scrollTo(0, 0); return; }

    var inicio = window.pageYOffset;
    var y = objetivoY(el);
    var dist = y - inicio;

    function corregir() {
      var y2 = objetivoY(el);
      if (Math.abs(y2 - window.pageYOffset) > 40) window.scrollTo(0, y2);
    }

    if (Math.abs(dist) < 2) { corregir(); return; }

    var duracion = Math.min(900, Math.max(400, 300 + Math.abs(dist) / 12));
    var arranco = false;
    var t0 = null;

    function paso(t) {
      arranco = true;
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / duracion, 1);
      var suave = 1 - Math.pow(1 - p, 3);
      window.scrollTo(0, inicio + dist * suave);
      if (p < 1) { requestAnimationFrame(paso); } else { corregir(); }
    }

    requestAnimationFrame(paso);

    setTimeout(function () {
      if (!arranco) { window.scrollTo(0, y); corregir(); }
    }, 400);
  }

  function arrancar() {
    var botones = document.querySelectorAll('[data-al-subir]');
    for (var i = 0; i < botones.length; i++) {
      botones[i].addEventListener('click', subir);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
